import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Button,
  Grid,
  TableHead,
  TableRow,
  TablePagination,
  Dialog,
  FormControl,
  InputLabel,
  OutlinedInput,
  MenuItem,
  ListItemText,
  DialogActions,
  Select,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
} from "@mui/material";
import Label from "src/components/Label";
import { ZoomIn, ZoomOut } from "@mui/icons-material";
import Scrollbar from "../components/Scrollbar";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { getEmployeeProduction, getEmployeeTrackingInfo } from "src/api/faceRegistration";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import { getURL } from "src/utils/config";
import axios from "axios";
import Page from "src/components/Page";
import { DateTimePicker } from '@mui/x-date-pickers';
import { LoadingButton } from '@mui/lab';

const EmployeeTrackingInfo = () => {
  //const [date, setDate] = useState(dayjs());
  const [combinedData, setCombinedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // for search filter
  const [searchText, setSearchText] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [apiData, setApiData] = useState(null);
  const [locationNames, setLocationNames] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState(null);

  const [loading, setLoading] = useState(false);

  const [locationError, setLocationError] = useState(false);

  const [fromDate, setFromDate] = useState(() => {

    return dayjs().startOf('day')

  });

  const [toDate, setToDate] = useState(() => {

    return dayjs().endOf('day')

  });

  const [fromDateError, setFromDateError] = useState(false);

  const [toDateError, setToDateError] = useState(false);



  const handleFromDateChange = (date) => {

    setFromDate(date);

    setFromDateError(false);

  };



  const handleToDateChange = (date) => {

    setToDate(date);

    setToDateError(false);

  };
  
  useEffect(() => {
    const fetchData = async () => {
      
      const apiUrl = getURL("employee-shifts-info/location-names?status=1");
      const AUTH_TOKEN = `${localStorage.getItem('token_type')} ${localStorage.getItem('access_token')}`;
      
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: AUTH_TOKEN,
          },
        });

        const extractedLocationNames = response.data.map(item => item.LocationName);
        setLocationNames(extractedLocationNames);
        
        setApiData(response.data);
      } catch (error) {
        console.error('Error:', error);
      }
    };
  
    fetchData();
  }, []);



  const updateLocation = (value) => {
    setSelectedLocation(value);
    const selectedLocationObject = apiData.find((location) => location.LocationName === value);
    setSelectedLocationId(selectedLocationObject ? selectedLocationObject.Id : null);
    localStorage.setItem("NetLocation", value);
    setLocationError(false)
  }

  useEffect(()=>{
    const savedLocation = localStorage.getItem("NetLocation");
    if(savedLocation && apiData) {
        updateLocation(savedLocation);
    }
  },[apiData])

  const handleLocationChange = (value) => {
    updateLocation(value);
  };


  const handleSubmit = () => {
    // setPage(0)
    //const formattedDate = dayjs(date).format("YYYY-MM-DD");
    const locationId = selectedLocationId || 0;

    setLoading(true);

    setLocationError(false);

    setFromDateError(false);

    setToDateError(false);



    if (locationId === 0 || fromDate === null || toDate === null) {

      if(locationId === 0) {

        setLocationError(true)

      }



      if(fromDate === null) {

        setFromDateError(true)

      }



      if(toDate === null) {

        setToDateError(true)

      }



      setLoading(false);



      return;

    }



    

    const combinedFromDateTime = dayjs(fromDate).format('YYYY-MM-DD HH:mm:ss');

    const combinedToDateTime = dayjs(toDate).format('YYYY-MM-DD HH:mm:ss');

    

    const data = {

      location_id: locationId,

      from_time: combinedFromDateTime,

      to_time: combinedToDateTime,

    };
    getEmployeeTrackingInfo(data, (response) => {
      if (response.status === 200) {
        setCombinedData(response.data);
        setFilteredData(response.data);
        setSearchText("");
        setPage(0);
      }
      setLoading(false);
    });
  };

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchText(query);

    if (!query) {
      setFilteredData(combinedData); // restore original
    } else {
      const filtered = combinedData.filter((item) =>
        item.Name?.toLowerCase().includes(query)
      );
      setFilteredData(filtered);
    }
  };

  const handleExportExcel = async () => {
    // const formattedDate = dayjs(date).format("YYYY-MM-DD");
    const combinedFromDateTime = dayjs(fromDate).format('YYYY-MM-DD');
    const combinedToDateTime = dayjs(toDate).format('YYYY-MM-DD');
    const formattedDate = combinedFromDateTime + '_TO_' + combinedToDateTime;

    if (combinedData.length !== 0) {
      // Create a new workbook and worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Production Report");
      // Define headers with styles
      worksheet.columns = [
        { header: "S.No", key: "sno", width: 10 },
        {
          header: "Employee Name",
          key: "employeeName",
          width: 35,
          alignment: { horizontal: "center" },
        },
        {
          header: "Location",
          key: "location",
          width: 15,
          alignment: { horizontal: "left" },
        },
        {
          header: "Contractor Name",
          key: "contractor",
          width: 20,
          alignment: { horizontal: "left" },
        },
        {
          header: "Department",
          key: "department",
          width: 15,
          alignment: { horizontal: "left" },
        },
        {
          header: "Entry Date",
          key: "entryDate",
          width: 15,
          alignment: { horizontal: "center" },
        },
        {
          header: "Entry Time",
          key: "entryTime",
          width: 15,
          alignment: { horizontal: "center" },
        },
        {
          header: "Entry Image",
          key: "entryImage",
          width: 85,
          alignment: { horizontal: "center" },
        },
        {
          header: "Exit Date",
          key: "exitDate",
          width: 15,
          alignment: { horizontal: "center" },
        },
        {
          header: "Exit Time",
          key: "exitTime",
          width: 15,
          alignment: { horizontal: "center" },
        },
        {
          header: "Exit Image",
          key: "exitImage",
          width: 85,
          alignment: { horizontal: "center" },
        },
        {
          header: "Status",
          key: "status",
          width: 15,
          alignment: { horizontal: "center" },
        },
        {
          header: "Present Status",
          key: "presentstatus",
          width: 15,
          alignment: { horizontal: "center" },
        },
        {
          header: "Duration",
          key: "duration",
          width: 15,
          alignment: { horizontal: "center" },
        },
        {
          header: "Overtime Duration",
          key: "over_time_hours",
          width: 25,
          alignment: { horizontal: "center" },
        },
        {
          header: "Undertime Duration",
          key: "under_time_hours",
          width: 25,
          alignment: { horizontal: "center" },
        },
      ];

      // Add rows with data
      combinedData.forEach((item, index) => {
        const row = worksheet.addRow({
          sno: index + 1,
          employeeName: item.Name,
          location: item.LocationName || "",
          contractor: item.ContractorName || "",
          department: item.DepartmentName || "",
          entryDate: item.entry_date || "",
          entryTime: item.entry_time || "",
          entryImage: item.entry_snapshot || "",
          exitDate: item.exit_date || "",
          exitTime: item.exit_time || "",
          exitImage: item.exit_snapshot || "",
          status: item.Status === 1 ? "Active" : "Terminated" || "",
          presentstatus: item.PresentStatus === 1 ? "Active" :  item.PresentStatus === 0 ? "Terminated" : "InActive",
          duration: item.duration || "",
          over_time_hours: item.over_time_hours || "N/A",
          under_time_hours: item.under_time_hours || "N/A"
        });

        // Apply alignment styles to all cells in the row
        row.eachCell((cell) => {
          cell.alignment = { horizontal: "center" };
        });
      });

      // Apply styles to headers
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: "center" };
      });

      // Generate and save the file
      const fileName = `ProductionHours_${formattedDate}.xlsx`;
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), fileName);
    } else {
      alert("No data to export.");
    }
    // });
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOpenDuration, setDurationDialogOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedDuration, setSelectedDuration] = useState([]);
  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [start, setStart] = useState({ x: 0, y: 0 });

  const handleImageClick = (url) => {
    setSelectedImage(url);
    setDialogOpen(true);
  };

  const handleDuration = (item) => {
    console.log(item.details);
    setSelectedDuration(item.details);
    setDurationDialogOpen(true);
  };
  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDurationDialogOpen(false);
    setSelectedImage(null);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  const handleZoom = (delta) => {
    setZoom((prev) => Math.max(1, Math.min(prev + delta, 3)));
  };
  const handleWheel = (e) => {
    e.preventDefault();
    handleZoom(e.deltaY < 0 ? 0.1 : -0.1);
  };
  const handleMouseDown = (e) => {
    setDragging(true);
    setStart({ x: e.clientX - position.x, y: e.clientY - position.y });
  };
  const handleMouseMove = (e) => {
    if (dragging) {
      setPosition({ x: e.clientX - start.x, y: e.clientY - start.y });
    }
  };
  const handleMouseUp = () => setDragging(false);

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const errorHelperSx = {
    minHeight: 20, // reserves space
    mt: 0.5,
  };

  return (  
    <Page title="Production Report">
    
        <Card>
          <CardContent>
          <Grid container spacing={2} alignItems="center" mx={2} my={2}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  flexWrap: 'wrap', // optional if screen can be small
                  gap: 2, // spacing between elements
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <FormControl sx={{  minWidth: 200, '& fieldset': { borderColor: fromDateError ? 'red' : 'initial' } }}>
                    <DateTimePicker
                      label="From Date"
                      id="from-date"
                      ampm={true}
                      format="YYYY-MM-DD HH:mm"
                      value={fromDate}
                      onChange={handleFromDateChange}
                      maxDate={dayjs()}
                    />

                    <Typography color="error" variant="body2" sx={errorHelperSx}>
                      {fromDateError ? "Please select From Date & Time" : " "}
                    </Typography>
                  </FormControl>
                </LocalizationProvider>


                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <FormControl sx={{  minWidth: 200, '& fieldset': { borderColor: fromDateError ? 'red' : 'initial' } }}>
                    <DateTimePicker
                      label="To Date"
                      id="to-date"
                      ampm={true}
                      format="YYYY-MM-DD HH:mm"
                      value={toDate}
                      onChange={handleToDateChange}
                      minDate={fromDate}
                      maxDate={dayjs()}
                    />
                    <Typography color="error" variant="body2" sx={errorHelperSx}>
                      {toDateError ? "Please Select To Date" : " "}
                    </Typography>
                  </FormControl>

                </LocalizationProvider>

                <FormControl sx={{  minWidth: 200, '& fieldset': { borderColor: fromDateError ? 'red' : 'initial' } }}>
                  <InputLabel id="select-label">Location</InputLabel>
                  <Select
                    labelId="select-label"
                    value={selectedLocation}
                    onChange={(e) => handleLocationChange(e.target.value)}
                    input={<OutlinedInput label="Select Location" />}
                  >
                    {locationNames.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                  <Typography color="error" variant="body2" sx={errorHelperSx}>
                    {locationError ? "Please Select Location" : " "}
                  </Typography>
                </FormControl>

                  <Box sx={{ display: 'flex', gap: 1, mt: -2 }}>
                    <LoadingButton type="submit" variant="contained" onClick={handleSubmit} loading={loading}>
                      Submit
                    </LoadingButton>

                    <LoadingButton type="submit" variant="contained" onClick={handleExportExcel}>
                      Export
                    </LoadingButton>
                  </Box>

                  <TextField
                  sx= {{
                    minWidth: 240, mt:-2}}
                    label="Search by Employee Name"
                    value={searchText}
                    onChange={handleSearch}
                    InputLabelProps={{
                      sx: {
                        fontSize: "1.2rem", // smaller label text
                      },
                    }}
                  />
              </Box>
            </Grid>

            <Box sx={{ width: '100%', overflowX: 'auto' }}>
              <TableContainer sx={{ minWidth: 1600 }}>
                <Table stickyHeader sx={{ minWidth: 1600 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>S.No</TableCell>
                      <TableCell>Employee Name</TableCell>
                      <TableCell>Location</TableCell>
                      <TableCell>Contractor Name</TableCell>
                      <TableCell>Department</TableCell>
                      <TableCell>Entry Date</TableCell>
                      <TableCell>Entry Time</TableCell>
                      <TableCell>Entry Image</TableCell>
                      <TableCell>Exit Date</TableCell>
                      <TableCell>Exit Time</TableCell>
                      <TableCell>Exit Image</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Present Status</TableCell>
                      <TableCell>Duration</TableCell>
                      <TableCell>Overtime Duration</TableCell>
                      <TableCell>Undertime Duration</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>{item.Name}</TableCell>
                        <TableCell>{item.LocationName}</TableCell>
                        <TableCell>{item.ContractorName}</TableCell>
                        <TableCell>{item.DepartmentName}</TableCell>
                        <TableCell>{item.entry_date || "N/A"}</TableCell>
                        <TableCell>{item.entry_time || "N/A"}</TableCell>
                        <TableCell>
                          {item.entry_snapshot ? (
                            <img
                              src={item.entry_snapshot}
                              alt="Entry"
                              style={{ width: 50, cursor: "pointer" }}
                              onClick={() =>
                                handleImageClick(item.entry_snapshot)
                              }
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                        <TableCell>{item.exit_date || "N/A"}</TableCell>
                        <TableCell>{item.exit_time || "N/A"}</TableCell>
                        <TableCell>
                          {item.exit_snapshot ? (
                            <img
                              src={item.exit_snapshot}
                              alt="Exit"
                              style={{ width: 50, cursor: "pointer" }}
                              onClick={() => handleImageClick(item.exit_snapshot)}
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                        <TableCell>
                          <Label
                            variant="ghost"
                            color={item.Status === 1 ? "success" : "error"}
                          >
                            {item.Status === 1 ? "Active" : "Terminated"}
                          </Label>
                        </TableCell>

                        <TableCell>
                          <Label
                            variant="ghost"
                            color={item.PresentStatus === 1 ? "success" : "error"}
                          >
                            {item.PresentStatus === 1 ? "Active" : item.PresentStatus === 2 ? "InActive" :"Terminated"}
                          </Label>
                        </TableCell>
                        <TableCell>
                          <span
                            onClick={() => {
                              if (item.duration !== "00:00:00" && item.details) {
                                handleDuration(item);
                              }
                            }}
                            style={{
                              cursor:
                                item.duration !== "00:00:00" && item.details
                                  ? "pointer"
                                  : "default",
                              color:
                                item.duration !== "00:00:00" && item.details
                                  ? "#6496e9"
                                  : "inherit",
                              fontWeight: "bold"
                            }}
                          >
                            {item.duration || "N/A"}
                          </span>
                        </TableCell>
                        <TableCell>{item.over_time_hours || "N/A"}</TableCell>
                        <TableCell>{item.under_time_hours || "N/A"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}


            />
          </CardContent>
        </Card>

        <Dialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Image Preview</DialogTitle>
          <DialogContent
            onWheel={handleWheel}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            sx={{ cursor: dragging ? "grabbing" : "grab" }}
          >
            {selectedImage && (
              <Box
                component="img"
                src={selectedImage}
                alt="Snapshot"
                sx={{
                  width: "100%",
                  maxHeight: "80vh",
                  transform: `scale(${zoom}) translate(${position.x}px, ${position.y}px)`,
                  transition: dragging ? "none" : "transform 0.3s ease-in-out",
                }}
              />
            )}
          </DialogContent>
          <DialogActions sx={{ justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <IconButton onClick={() => handleZoom(-0.2)} disabled={zoom <= 1}>
                <ZoomOut />
              </IconButton>
              <Typography>{Math.round(zoom * 100)}%</Typography>
              <IconButton onClick={() => handleZoom(0.2)} disabled={zoom >= 3}>
                <ZoomIn />
              </IconButton>
              <Button onClick={handleCloseDialog} variant="contained">
                Reset
              </Button>
            </Box>
            <Button onClick={handleCloseDialog} color="error" variant="contained">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={dialogOpenDuration}
          onClose={() => setDurationDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Entry & Exit Report</DialogTitle>
          <DialogContent>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Preview</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Date</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Time</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Direction</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedDuration.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {row.Snapshot ? (
                        <img
                          src={row.Snapshot}
                          alt="Preview"
                          style={{ width: 50, cursor: "pointer" }}
                        />
                      ) : (
                        "N/A"
                      )}
                    </TableCell>

                    <TableCell>{row.FaceDate || "N/A"}</TableCell>
                    <TableCell>{row.FaceTime || "N/A"}</TableCell>

                    
                    <TableCell>
                      <Label
                            variant="ghost"
                            color={row.Direction === 'entry' ? "success" : "error"}
                          >
                            {row.Direction || "N/A"}
                          </Label>                    
                      </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setDurationDialogOpen(false)}
              variant="contained"
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
     
    </Page>
  );
};

export default EmployeeTrackingInfo;
